export default "__VITE_PUBLIC_ASSET__08ec544f__"